import { Component } from '@angular/core';
import { NotificationsWidget } from './components/notificationswidget';
import { StatsWidget } from './components/statswidget';
import { RecentSalesWidget } from './components/recentsaleswidget';
import { BestSellingWidget } from './components/bestsellingwidget';
import { RevenueStreamWidget } from './components/revenuestreamwidget';
import { DashboardActiveDailyComponent } from "@/project/dashbord/report-customer-active/report-customer-active";

@Component({
    selector: 'app-dashboard',
    standalone: true,
    imports: [
        StatsWidget,
        RecentSalesWidget,
        BestSellingWidget,
        RevenueStreamWidget,
        NotificationsWidget,
        DashboardActiveDailyComponent
    ],
    template: `
        <div class="grid grid-cols-12 gap-8">

            <!-- چهار کارت بالا -->
            <app-stats-widget class="contents" />

            <!-- ✅ بنر -->
            <div class="col-span-12">
                <div class="w-full overflow-hidden rounded-2xl shadow-lg">
                    <img
                        src="assets/images/ok.jpg"
                        alt="Dashboard Banner"
                        class="w-full h-auto object-cover"
                    />
                </div>
            </div>

            <!-- ویجت های پایین -->
            <div class="col-span-12 xl:col-span-6">
                <app-recent-sales-widget />
            </div>

            <div class="col-span-12 xl:col-span-6">
                <app-revenue-stream-widget />
            </div>

        </div>
    `
})
export class Dashboard {}
